import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    marginTop: theme.spacing(4),
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(2),
    },
  },
}));

const AppFormButtons: React.FC = ({ children }) => {
  const classNames = useStyles();

  return <div className={classNames.root}>{children}</div>;
};

export default AppFormButtons;
